import React, { useEffect, useState } from 'react';
import Marquee from 'react-fast-marquee';
import BannerSlider from '../components/BannerSlider';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProducts } from '../features/products/productSlice';
import axiosInstance, { base_url } from '../utils/axiosConfig';
import { useNavigate } from 'react-router-dom';
import ConsultationPage from './ConsultationPage';
import TravelPage from './TravelPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import HeroSection from './HeroSection';
import RecentltAddProducts from './RecentltAddProducts';
import BestSelling from '../components/BestSelling';

const ORANGE = '#ff6701';
const DARK   = '#232f3e';

const Home = () => {
  const dispatch     = useDispatch();
  const navigate     = useNavigate();
  const productState = useSelector((state) => state.product.product);
  const [brands, setBrands] = useState([]);
  const [offer,  setOffer]  = useState([]);

  useEffect(() => {
    if (productState.length === 0) dispatch(getAllProducts());
  }, [dispatch, productState]);

  useEffect(() => {
    axiosInstance.get('/master/getbrand').then(r => setBrands(r.data[0]?.images || [])).catch(() => {});
  }, []);

  useEffect(() => {
    axiosInstance.get('/master/getoffer').then(r => setOffer(r.data[0]?.images || [])).catch(() => {});
  }, []);

  return (
    <>
      {/* ── Hero ── */}
      <HeroSection />

      {/* ── Banner Slider ── */}
      <section style={s.sectionWrap}>
        <BannerSlider />
      </section>

      {/* ── Best Selling ── */}
      <BestSelling />

      {/* ── Consultation ── */}
      <ConsultationPage />

      {/* ── Offer Banners ── */}
      {offer.length > 0 && (
        <section style={{ ...s.sectionWrap, backgroundColor: '#f5f5f7' }}>
          <div style={s.container}>
            <div style={s.sectionHead}>
              <h2 style={s.sectionTitle}>🔥 Hot Deals</h2>
              <p style={s.sectionSub}>Limited-time offers just for you</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              {offer.map((imgObj) => (
                <div key={imgObj._id} style={s.offerWrap}>
                  <img
                    src={`${base_url}${imgObj.url}`}
                    style={s.offerImg}
                    alt="Offer Banner"
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ── Recently Added ── */}
      <RecentltAddProducts />

      {/* ── Travel / Explore ── */}
      <TravelPage />

      {/* ── Brand Marquee ── */}
      {brands.length > 0 && (
        <section style={{ ...s.sectionWrap, backgroundColor: '#fff', borderTop: '1px solid #f0f0f0' }}>
          <div style={s.container}>
            <div style={s.sectionHead}>
              <h2 style={s.sectionTitle}>Brands We Carry</h2>
              <p style={s.sectionSub}>Trusted by top names across India</p>
            </div>
          </div>
          <div style={s.marqueeWrap}>
            <Marquee gradient={false} speed={50} pauseOnHover>
              {brands.map((brandImg) => (
                <div key={brandImg._id} style={s.brandItem}>
                  <img
                    src={`${base_url}${brandImg.url}`}
                    alt="brand"
                    style={s.brandImg}
                  />
                </div>
              ))}
            </Marquee>
          </div>
        </section>
      )}
    </>
  );
};

const s = {
  sectionWrap: { padding: '40px 0' },
  container:   { maxWidth: 1100, margin: '0 auto', padding: '0 20px' },
  sectionHead: { textAlign: 'center', marginBottom: 28 },
  sectionTitle: {
    fontSize: 22, fontWeight: 800, color: '#1c1c1b',
    margin: '0 0 6px', fontFamily: '"Rubik", "Poppins", sans-serif',
  },
  sectionSub: {
    fontSize: 13, color: '#888', margin: 0,
    fontFamily: '"Rubik", "Poppins", sans-serif',
  },
  offerWrap: {
    borderRadius: 14, overflow: 'hidden',
    boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
  offerImg: {
    width: '100%', display: 'block',
    objectFit: 'cover', borderRadius: 14,
  },
  marqueeWrap: {
    padding: '12px 0',
    borderTop: '1px solid #f5f5f7',
    borderBottom: '1px solid #f5f5f7',
    backgroundColor: '#fafafa',
  },
  brandItem: {
    marginRight: 40,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '8px 0',
  },
  brandImg: {
    maxWidth: 110, maxHeight: 60,
    objectFit: 'contain', filter: 'grayscale(20%)',
    transition: 'filter 0.2s',
    opacity: 0.85,
  },
};

export default Home;
